const actualYear = new Date().getFullYear();
export default actualYear;
